import { cx } from "class-variance-authority";

import { TourSelectors } from "@/config/tour.config";

export const NumbersMobile = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <div
      className={cx("scrollbar-hide flex flex-row items-center gap-4 overflow-x-auto py-4 pr-6 t:pl-3-5", className)}
      id={TourSelectors.YourNumbersSection}
    >
      {children}
    </div>
  );
};
